import { RichText } from "../components/RichText";
import type { ProseBlock } from "../contract/types";
import type { BlockViewProps } from "./types";

/**
 * Texto enriquecido: markdown con GFM (tablas, tachado, listas de tareas),
 * matemática inline `$…$` y en bloque `$$…$$` vía KaTeX, y citas.
 *
 * Las citas se escriben como enlaces `[M4, p. 12](#src-M4)` y se pintan como
 * una marca sobria que remite a la fuente en el rail derecho.
 *
 * El render vive en `components/RichText`, compartido con los demás átomos que
 * llevan prosa: el agente escribe markdown en todos ellos, no solo aquí.
 */
export function Prose({ block }: BlockViewProps<ProseBlock>) {
  return (
    <div className="atom atom--prose">
      <RichText>{block.markdown}</RichText>
    </div>
  );
}

export default Prose;
